import { Extractor } from "./../types";

export default class TextExtractor implements Extractor {
  extract(target: HTMLElement): Record<string, unknown> {
    return {
      text: target.textContent?.trim(),
    };
  }
}
